import { render, staticRenderFns } from "./ClientRequestedClass.vue?vue&type=template&id=29e738be&scoped=true&"
import script from "./ClientRequestedClass.vue?vue&type=script&lang=js&"
export * from "./ClientRequestedClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e738be",
  null
  
)

export default component.exports